import React, { createContext, useContext, useState } from 'react';

interface PostedJobsPageContextType {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  clearPage: () => void;
  keyword: string;
  setKeyword: (kw: string) => void;
}

const PostedJobsPageContext = createContext<
  PostedJobsPageContextType | undefined
>(undefined);

export const usePostedJobsPage = () => {
  const context = useContext(PostedJobsPageContext);
  if (!context) {
    throw new Error(
      'usePostedJobsPage must be used within a PostedJobsPageProvider'
    );
  }
  return context;
};

export const PostedJobsPageProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [currentPage, setCurrentPageState] = useState<number>(() => {
    const stored = localStorage.getItem('postedJobsCurrentPage');
    return stored ? Number(stored) : 1;
  });

  const setCurrentPage = (page: number) => {
    setCurrentPageState(page);
    localStorage.setItem('postedJobsCurrentPage', String(page));
  };

  const clearPage = () => {
    localStorage.removeItem('postedJobsCurrentPage');
    setCurrentPageState(1);
  };
  const [keyword, setKeyword] = useState<string>('');

  return (
    <PostedJobsPageContext.Provider
      value={{ currentPage, setCurrentPage, clearPage, keyword, setKeyword }}
    >
      {children}
    </PostedJobsPageContext.Provider>
  );
};
